import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import appReducer from "./app";
import constantsReducer from "./constants";
import dataReducer from "./data";
import sessionReducer from "./session";
import userReducer from "./user";

const createRootReducer = history => {
  const reducerBase = combineReducers({
    router: connectRouter(history),
    app: appReducer,
    constants: constantsReducer,
    data: dataReducer,
    session: sessionReducer,
    user: userReducer
  });

  const rootReducer = (state, action) => {
    if (action.type === "RESET_APP") {
      state = undefined;
    }

    return reducerBase(state, action);
  };

  return rootReducer;
};

export default createRootReducer;
